$('.news-archive .filter .current-item').click(function(e) {
    e.preventDefault();

    const $this = $(this);
    $this.parent().toggleClass('open');
});

// Store country link
$('.news-archive .careers-link-country a').click(function(e) {
    e.preventDefault();
    const $this = $(this);
    const countryLink = window.location.href;

    if($this.hasClass("careers-link")) {
        const link = localStorage.getItem('country-link-careers', countryLink);
        if(link) {
            location.href = link;
        } else {
            location.href = window.location.href.split("careers")[0] + "/world/articles";
        }
    } else {
        localStorage.setItem('country-link-careers', window.location.href);
        const linkStart = window.location.href.split(".");
        const linkMiddle = linkStart[1].split("/");
        let link = "";

        if(countryLink.indexOf("staging") !== -1) {
            link = linkStart[0] + "." + linkStart[1] + "." + linkStart[2].split("/")[0] + "/careers/stories";
        } else {
            link = linkStart[0] + "." + linkMiddle[0] + "/careers/stories"; 
        }
        location.href = link;
    }
});

var $newsArchive = $('.news-archive');
var $primary = $('.news-archive .primary');
var $filter = $('.news-archive .filter');

if ($('.news-archive').length > 0) {

    var filterTop = $filter.offset().top;

    $(window).scroll(function(e) {
        var scrollTop = $(this).scrollTop();
        var primaryHeight = $primary.height();
        var marginTop = $newsArchive.css('marginTop').replace('px', '');

        if (scrollTop > filterTop - 64) {
            $filter.addClass('sticky');
        } else {
            $filter.removeClass('sticky');
        }

        if (scrollTop > primaryHeight) {
            $filter.css('transform', 'translateY(-' + (scrollTop - primaryHeight - marginTop / 2) + 'px)');
        } else {
            $filter.css('transform', 'translateY(0)');
        }
    });
}